var _defs, _path, _path2, _path3, _ellipse, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons8-instagram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43.992,
    height: 43.992,
    viewBox: "0 0 43.992 43.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient",
    cx: 0.372,
    cy: 1.001,
    r: 1.247,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#ff543f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#fc5245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#e64771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#d53e91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#cc39a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#c837ab"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.161,
    cy: -0.012,
    r: 0.828,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4168c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#4168c9",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M40.221,49.959l-24.427.023a9.8,9.8,0,0,1-9.781-9.761L5.99,15.794a9.8,9.8,0,0,1,9.761-9.781L40.178,5.99a9.8,9.8,0,0,1,9.781,9.761l.023,24.427A9.8,9.8,0,0,1,40.221,49.959Z",
    transform: "translate(-5.99 -5.99)",
    fill: "url(#gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M40.221,49.959l-24.427.023a9.8,9.8,0,0,1-9.781-9.761L5.99,15.794a9.8,9.8,0,0,1,9.761-9.781L40.178,5.99a9.8,9.8,0,0,1,9.781,9.761l.023,24.427A9.8,9.8,0,0,1,40.221,49.959Z",
    transform: "translate(-5.99 -5.99)",
    fill: "url(#radial-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M25.549,34.1A8.549,8.549,0,1,1,34.1,25.549,8.56,8.56,0,0,1,25.549,34.1Zm0-14.656a6.107,6.107,0,1,0,6.107,6.107A6.114,6.114,0,0,0,25.549,19.443Z",
    transform: "translate(-3.553 -3.553)",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 1.832,
    cy: 1.832,
    rx: 1.832,
    ry: 1.832,
    transform: "translate(29.325 11.004)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M34.206,42.755H19.549A8.56,8.56,0,0,1,11,34.206V19.549A8.56,8.56,0,0,1,19.549,11H34.206a8.56,8.56,0,0,1,8.549,8.549V34.206A8.56,8.56,0,0,1,34.206,42.755ZM19.549,13.443a6.114,6.114,0,0,0-6.107,6.107V34.206a6.114,6.114,0,0,0,6.107,6.107H34.206a6.114,6.114,0,0,0,6.107-6.107V19.549a6.114,6.114,0,0,0-6.107-6.107Z",
    transform: "translate(-4.881 -4.881)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.2a962d28d26a14bde526d73523950cf2.svg";
export { ForwardRef as ReactComponent };